import Trojan1 from '@icons/trojan1.svg';
import Trojan2 from '@icons/trojan2.svg';
import Trojan3 from '@icons/trojan3.svg';
import type { TrojanHorseCard } from '@components/widgets';

/**
 * “Trojan Horse” problem cards for the brokers use case (Big Tech ICHRA platforms).
 */
export const BROKERS_TROJAN_HORSE_CARDS: TrojanHorseCard[] = [
    {
        iconSrc: Trojan1,
        iconAlt: '',
        title: 'Revenue Cannibalization',
        description:
            'The leading vendor quoted a fee of $35 PEPM (Per Employee Per Month). For a 120-life group, that’s $50,400 per year just for the software, nearly equal to the broker’s own commission.',
    },
    {
        iconSrc: Trojan2,
        iconAlt: '',
        title: 'BOR Threat',
        description:
            'The vendor’s contract required the broker firm to cede BOR status to the platforms in-house agency, turning the broker into a "referral partner" rather than the lead advisor.',
    },
    {
        iconSrc: Trojan3,
        iconAlt: '',
        title: 'Brand Disconnect',
        description:
            'The platform was "platform-branded." Employees would log into the vendor’s portal, effectively making the vendor the face of the benefits program.',
    },
];
